import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';
import { isBefore } from 'date-fns';

import InfoIcon from '@atlaskit/icon/core/migration/information--info';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { usePageAnalyticsStore } from '../../store/pageAnalyticsStore';

const i18n = defineMessages({
	engagementAvailabilityMessage: {
		id: 'confluence-analytics.overview-tab.engagement-availability-message',
		defaultMessage:
			'Engagement status data is only available from February 24, 2025 onwards. Views before this date will not have their engagement tracked.',
		description:
			'Engagement data will not show up in the table if the content was viewed before the specified date. This message is intended to inform end users of this limitation.',
	},
});

const messageContainerStyles = xcss({
	color: 'color.text',
	backgroundColor: 'color.background.information',
	paddingTop: 'space.200',
	paddingLeft: 'space.150',
	paddingBottom: 'space.200',
	paddingRight: 'space.300',
});

const messageStyles = xcss({
	marginLeft: 'space.150',
});

// This date is hardcoded to when we started tracking engagement in Confluence through CC-Analytics.
export const ENGAGEMENT_START_DATE = new Date('2025-02-24 00:00:00');

export const EngagementViewsInfoMessage = () => {
	const { state } = usePageAnalyticsStore();

	const pageCreatedDate = state.contentCreatedDate;
	const shouldShowInfoMessage =
		pageCreatedDate && isBefore(new Date(pageCreatedDate), ENGAGEMENT_START_DATE);

	if (shouldShowInfoMessage) {
		return (
			<Inline alignBlock="center" xcss={messageContainerStyles}>
				<InfoIcon
					label=""
					LEGACY_size="medium"
					spacing="spacious"
					color={token('color.icon.brand')}
				/>
				<Box xcss={messageStyles}>
					<FormattedMessage {...i18n.engagementAvailabilityMessage} />
				</Box>
			</Inline>
		);
	} else {
		return null;
	}
};
